import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TsComponent } from '../../ts.component';
import { WidgetsModule } from '@shared/components/widgets/widgets.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import { Activity } from '@core/models';
import { AsyncPipe } from '@angular/common';
import { RelatedToType } from '@shared/enums';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { TsSkeletonComponent } from 'tsui/lib/ts-skeleton/ts-skeleton.component';

@Component({
  selector: 'app-activity',
  standalone: true,
  imports: [WidgetsModule, AsyncPipe, TsSkeletonComponent],
  templateUrl: './activity.component.html',
  styleUrl: './activity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterActivityTabComponent extends TsComponent {
  activities$: Observable<Activity[]>;
  relatedTo: string;

  ngOnInit(): void {
    this.activities$ = this.activatedRoute.params.pipe(
      takeUntilDestroyed(this.destroyRef),
      switchMap((params: { relatedToKey; recordId }) => {
        const obj = this.store.selectSnapshot(ObjectsManagerState.getByUrlPrefix(params.relatedToKey));
        this.relatedTo = obj.name;
        return this.accountService.getActivities({
          per_page: 25,
          related_to_id: params.recordId,
          related_to_type: this.relatedTo.includes('co_') ? RelatedToType.CustomObjectValue : this.relatedTo,
        });
      }),
    );
  }
}
